import React from 'react';
import AutoSuggestionSelectComponent from '../common/auto-suggestion-select/AsyncSelect';
import { axiosInstance } from '../../../api/axios';
import APIEndpoints from '../../api/APIEndpoints';

export const SpecialtySelectInput = ({
  onChangeHandler,
  value,
  valueLabel,
}) => {
  const searchTypes = async (input) => {
    try {
      if (!input || input.length < 3) {
        return [];
      }
      const url =
        APIEndpoints.getDoctorTypeSuggestions() +
        input +
        '/pagenumber/1/pagesize/10';
      const response = await axiosInstance.get(url);
      return [...response.data.Response.SearchDoctors].map((val) => {
        return { label: val, value: val };
      });
    } catch (error) {
      return null;
    }
  };

  return (
    <AutoSuggestionSelectComponent
      onChange={onChangeHandler}
      inputClassName="border-right-0"
      components={{ IndicatorSeparator: () => null }}
      placeholder="Enter a specialty"
      value={
        value ? { label: valueLabel ? valueLabel : value, value: value } : null
      }
      fetchOptions={searchTypes}
      //labelText="Specialty"
      isClearable={true}
    />
  );
};
